import { Validator } from '@block-explorer/entities';
import { isValidPublicKey } from '../utils/account';
import { isObjEmpty } from '../utils/object';

export const getValidatorWithInfo = ({
  validators,
}: {
  validators: Validator[];
}) =>
  validators.map((bid) => {
    const isVerifiedValidator =
      isValidPublicKey(bid.key) && !isObjEmpty(bid.accountInfo?.info);

    return {
      ...bid,
      isVerifiedValidator,
    };
  });
